.grids {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.buttonContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 20px;
}

.buttonTop {
    margin-bottom: 20px;
}

.list {
    margin: 0;
    position: relative;
    list-style: none;
    background-color: #fff;
    width: 100%;
    border: var(--hps-blue) solid 1px;
    border-radius: 4.5px;
    height: 400px;
}

.listContainer {
    width: 100%;
    min-width: 0;
}

.listHeading {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.listSubHeader {
    padding-left: 10px;
}

.search {
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
    align-items: flex-end;
}

.searchButton {
    width: 50%;
    padding-right: 10px;
}

.scrollContainer {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;
    scrollbar-color: rgba(0, 0, 0, 0.2) transparent; /* thumb color, track color */
}

/* Custom scrollbar styles */
.scrollContainer::-webkit-scrollbar {
    width: 8px;
}

.scrollContainer::-webkit-scrollbar-track {
    background: transparent; /* Match the background color */
}

.scrollContainer::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2); /* Slightly lighter shade for the thumb */
    border-radius: 4px;
}

.scrollContainer::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.2); /* Slightly lighter shade on hover */
}
